var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function updateStepByPath(pathUrl, detailsData) {
    var stepsRaw = localStorage.getItem("steps");
    if (!stepsRaw)
        return console.error("No se encontró el localStorage con clave 'steps'");
    var steps = JSON.parse(stepsRaw);
    if (!steps.length)
        return console.warn("El array de steps está vacío");
    var index = steps.findIndex(function (_a) {
        var p = _a.pathUrl;
        return p === pathUrl;
    });
    if (index === -1)
        return console.warn("No se encontr\u00F3 ning\u00FAn step con pathUrl: ".concat(pathUrl));
    steps[index] = __assign(__assign({}, steps[index]), { details: detailsData
            ? __assign(__assign({}, steps[index].details), detailsData) : steps[index].details, state: "complete" });
    var next = steps[index + 1];
    if ((next === null || next === void 0 ? void 0 : next.state) === "initialState") {
        steps[index + 1] = __assign(__assign({}, next), { state: "inProgress" });
    }
    localStorage.setItem("steps", JSON.stringify(steps));
}
